import { render } from "./ListMyBusiness.vue?vue&type=template&id=53e013d2"
import script from "./ListMyBusiness.vue?vue&type=script&lang=js"
export * from "./ListMyBusiness.vue?vue&type=script&lang=js"

import "./ListMyBusiness.vue?vue&type=style&index=0&id=53e013d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__